const StageEvent = {}
export default StageEvent;

//commands for setting stage activity stuff
StageEvent.ACTIVATE = "StageEvent.ACTIVATE";
StageEvent.DEACTIVATE = "StageEvent.DEACTIVATE";
StageEvent.RENDER_ONCE = "StageEvent.RENDER_ONCE";
StageEvent.INIT = "StageEvent.INIT";
